export var ObjType = /* @__PURE__ */ ((ObjType2) => {
  ObjType2["GEO"] = "geo";
  ObjType2["CUBE_CAMERA"] = "cubeCamera";
  ObjType2["AUDIO_LISTENER"] = "audioListener";
  ObjType2["POSITIONAL_AUDIO"] = "positionalAudio";
  ObjType2["SCENE"] = "scene";
  return ObjType2;
})(ObjType || {});
